<template>
    <div class="common_select">
        <v-select v-if="isRenderCustom" item-value="key" item-text="value" :label="label" :items="items" :value="selectedValue" :disabled="disabled" :required="required" :variant="variant" @input="updateSelectedValue"></v-select>
        <v-select v-else :label="label" :items="items" :value="selectedValue" :disabled="disabled" :required="required" :variant="variant" @input="updateSelectedValue"></v-select>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        variant: {
            type: String,
            default: 'outlined',
        },
        items: {
            type: Array,
            default: () => [],
        },
        value: {
            type: [String, Number, Array],
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        isRenderCustom: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedValue: this.value,
        }
    },
    watch: {
        value(newValue) {
            this.selectedValue = newValue
        },
    },
    methods: {
        updateSelectedValue(value) {
            this.selectedValue = value
            this.$emit('input', value)
        },
    },
}
</script>
<style lang="scss">
@import '~ThemePath/scss/common/_select.scss';
</style>
